import { AddPatientModal } from "../components/AddPatientModal";
import { AdministrationReportModal } from "../components/AdministrationReportModal";
import { ChronicProductModal } from "../components/ChronicProductModal";
import { EventsModal } from "../components/EventsModal";
import { BillingHistoryModal, HistoryModal, RobotPdaHistoryModal } from "../components/HistoryModals";
import { MergeConflictModal } from "../components/MergeConflictModal";
import { PatientDocumentsModal } from "../components/PatientDocuments";
import { PatientIdentityModal } from "../components/PatientIdentityModal";

export function renderModals(view) {
    const { addPatientOpen, billingHistoryRow, chronicProductRow, confirmMerge, createPatient, deletePatient, deletePatientDocument, documentBusyIds, documentCurrent, downloadAdministrationReport, eventsModal, historyRow, identityCurrent, mergeConflict, openPatientDocument, refreshEventPatient, reportLoading, reportModalOpen, reportRows, robotHistoryRow, savePatientIdentity, savingIds, selectedEhpadName, selectedEhpadSubcategories, setAddPatientOpen, setBillingHistoryRow, setChronicProductRow, setDocumentRow, setEventsModal, setHistoryRow, setIdentityRow, setMergeConflict, setReportModalOpen, setRobotHistoryRow, updateReportRow, uploadPatientDocument } = view;
    return (
    <>
        {eventsModal && <EventsModal config={eventsModal} onClose={() => setEventsModal(null)} onChanged={refreshEventPatient} />}
        {chronicProductRow && (
            <ChronicProductModal
                row={chronicProductRow}
                onClose={() => setChronicProductRow(null)}
                onChanged={() => refreshEventPatient(chronicProductRow.patientId)}
            />
        )}
        {billingHistoryRow && <BillingHistoryModal row={billingHistoryRow} onClose={() => setBillingHistoryRow(null)} />}
        {robotHistoryRow && <RobotPdaHistoryModal row={robotHistoryRow} onClose={() => setRobotHistoryRow(null)} />}
        {historyRow && <HistoryModal row={historyRow} onClose={() => setHistoryRow(null)} />}
        {documentCurrent && (
            <PatientDocumentsModal
                row={documentCurrent}
                busy={Boolean(documentBusyIds[documentCurrent.patientId])}
                onClose={() => setDocumentRow(null)}
                onUpload={file => uploadPatientDocument(documentCurrent.patientId, file)}
                onOpen={document => openPatientDocument(documentCurrent.patientId, document)}
                onDelete={document => deletePatientDocument(documentCurrent.patientId, document)}
            />
        )}
        {identityCurrent && (
            <PatientIdentityModal
                row={identityCurrent}
                productionSubcategories={selectedEhpadSubcategories}
                onClose={() => setIdentityRow(null)}
                onSave={identity => savePatientIdentity(identityCurrent, identity)}
                onDelete={() => deletePatient(identityCurrent.patientId)}
                onUploadDocument={file => uploadPatientDocument(identityCurrent.patientId, file)}
                onOpenDocument={document => openPatientDocument(identityCurrent.patientId, document)}
                onDeleteDocument={document => deletePatientDocument(identityCurrent.patientId, document)}
                documentBusy={Boolean(documentBusyIds[identityCurrent.patientId])}
            />
        )}
        {addPatientOpen && (
            <AddPatientModal
                ehpadName={selectedEhpadName}
                productionSubcategories={selectedEhpadSubcategories}
                onClose={() => setAddPatientOpen(false)}
                onCreated={createPatient}
            />
        )}
        {mergeConflict && (
            <MergeConflictModal
                conflict={mergeConflict}
                saving={Boolean(savingIds[mergeConflict.patientId])}
                onChoice={(field, choice) => setMergeConflict(current => ({
                    ...current,
                    choices: { ...current.choices, [field]: choice },
                }))}
                onCancel={() => setMergeConflict(null)}
                onConfirm={confirmMerge}
            />
        )}
        {reportModalOpen && (
            <AdministrationReportModal
                rows={reportRows}
                ehpadName={selectedEhpadName}
                loading={reportLoading}
                onChangeRow={updateReportRow}
                onDownload={downloadAdministrationReport}
                onClose={() => setReportModalOpen(false)}
            />
        )}
    </>
    );
}
